module.exports = __webpack_public_path__ + "img/goods_title.d8652cd6.svg";